import React, { useEffect, useRef } from "react";
import article_img1 from "../../assets/images/webp/course_img1.jpg";
import article_img2 from "../../assets/images/webp/course_img2.jpg";
import article_img3 from "../../assets/images/webp/course_img3.jpg";
import right_arrow from "../../assets/images/svg/right_arrow.svg";
import { Link } from "react-router-dom";
import "../../styles/animatica.css";
import "../../styles/skilling.css";

const COURSES = [
  {
    image: article_img1,
    title: "Film Production",
    text: "Unleash creativity with courses tailored for aspiring Actors, Directors, Directors of Photography (DOP), Editors, and Prosthetics Artists. These programs provide comprehensive training in cinematic storytelling, technical mastery, and on-set expertise, setting students on a path to success in the film industry.",
  },
  {
    image: article_img2,
    title: "Digital Media",
    text: "Shape the future of marketing with courses in SEO, Digital Marketing, Social Media Management, Graphic Design, and Content Strategy. Designed to meet industry demands, these programs equip students with the skills to create impactful campaigns and thrive in the digital space.",
  },
  {
    image: article_img3,
    title: "AVGC-XR",
    text: "Enter the next generation of entertainment with courses in Animation, VFX, Gaming, Comics, Augmented Reality (AR), Virtual Reality (VR), and Extended Reality (XR). Our state-of-the-art curriculum ensures students become pioneers in crafting immersive, high-tech experiences.",
  },
];

const OurCourses = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="an-section skilling-home-section py-5">
      <div className="an-glow an-glow-right" />
      <div className="container position-relative">
        <span className="an-reveal an-reveal-d1 an-eyebrow justify-content-center w-100">
          Learn With HKI
        </span>
        <h4 className="an-reveal an-reveal-d2 fs_35 ff_s fw-bold an-title-gradient d-block text-center mb-0">
          Our Courses
        </h4>
        <div className="row">
          {COURSES.map((course, index) => (
            <div key={course.title} className={`an-reveal an-reveal-d${index + 3} col-md-4 mt-4`}>
              <div className="oc-card">
                <img loading="lazy" decoding="async" className="oc-image" src={course.image} alt={course.title} />
                <div className="oc-overlay" />
                <div className="oc-content">
                  <h3 className="oc-title">{course.title}</h3>
                  <p className="oc-desc">{course.text}</p>
                  <Link to="/contact-us">
                    <span className="oc-cta">Inquire Now &rarr;</span>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="an-reveal an-reveal-d5 d-flex justify-content-center mt-5">
          <Link to="/courses">
            <p className="mb-0 cursor-pointer fs_17 ff_n fw-bold skilling-view-all">
              View All Courses &nbsp;
              <img loading="lazy" decoding="async" src={right_arrow} alt="right_arrow" />
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OurCourses;
